/**
 * On Aderant a line item's tax code and its input-tax jurisdiction are the same
 * code, but stored in two shapes: `TaxCode` as a scalar and `JurisdictionId` as
 * the `{value, label}` option the export reads for `InputTaxJurisdictionId`.
 * They drift apart (e.g. a stale supplier default), so when either is edited we
 * mirror it onto the other. Label falls back to the code — the export uses only
 * `.value` and the dropdown rebuilds the rich label on reopen.
 */

const isBlank = (value) => [undefined, null, ''].includes(value);

// Asymmetric clear: TaxCode drives the line's tax math, so clearing it
// clears JurisdictionId too. The reverse — clearing the export-only
// JurisdictionId — skips, so a stray dropdown clear can't silently wipe the
// tax dimension. Returns true when TaxCode was rewritten (caller must
// recompute Tax1/Tax2).
export function syncLineTaxJurisdiction(line, subSubField, value, status) {
  if (!line) return false;

  if (subSubField === 'TaxCode') {
    if (isBlank(value)) {
      line.JurisdictionId = undefined;
      line.JurisdictionIdStatus = undefined;
    } else {
      line.JurisdictionId = { value, label: value };
      line.JurisdictionIdStatus = status;
    }
    return false;
  }

  if (subSubField === 'JurisdictionId') {
    const code = value && typeof value === 'object' ? value.value : value;
    if (isBlank(code)) return false;
    line.TaxCode = code;
    line.TaxCodeStatus = status;
    return true;
  }

  return false;
}
